import React  from 'react';
import PropTypes from 'prop-types';
import HealthSelector from "../../../../gd-components/health/health-selector";

export default function ProjectHealthInList(props) {
    return (
        <HealthSelector className={props.renderMode} value={props.item.health} disabled={props.disabled} onChange={props.onChange}/>
    );
}

ProjectHealthInList.propTypes = {
    renderMode: PropTypes.oneOf(['list','view']),

    item: PropTypes.object,
    disabled: PropTypes.bool,

    onChange: PropTypes.func
};